/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(".bn-burger").click(function(){
  $("body").toggleClass("navigation-open")
})
$(".slick-slide-product").slick({
		infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow: true,
  fade: false,
  asNavFor: '.slider-nav-thumbnails'

});
 $('.slider-nav-thumbnails').slick({
 	slidesToShow: 5,
 	slidesToScroll: 1,
 	asNavFor: '.slick-slide-product',
 	dots: false,
 	infinite:false,
 	focusOnSelect: true,
   	useTransform:false,
   	vertical:true,
    verticalSwiping:true,
    responsive: [
      {
        breakpoint:1080,
          settings:{
            vertical:false,
    		verticalSwiping:false,
            slidesToShow: 3,
 			slidesToScroll: 1,
            

          }
        }]
 
 });


// 	var bn_window_with = $(window).width();

//     if(bn_window_with <= 1080) {
//       $('.slider-nav-thumbnails').slick({
//         vertical: false,
//         verticalSwiping:false,

//       });
//     } 
 


  // Remove active class from all thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

 // Set active class to first thumbnail slides
 $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

 // On before slide change match active thumbnail to current slide
 $('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
 	var mySlideNumber = nextSlide;
 	$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
 	$('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
});	
 $(".img-galery-item-how img").click(function(){
  $('#overlay')
    .css({backgroundImage: `url(${this.src})`})
    .addClass('open')
    .one('click', function() { $(this).removeClass('open'); });
})
 	
 var bn_boll = true
 
 $('.bn_faq').find($("p")).each(function(index,item){
 
 	console.log(index)
    if(index % 2 != 0){
      $(this).css({"display":"none"})
    }else{
      $(this).css({"position":"relative"})     
      $(this).append("<span class='bn_open_answer'>+</span>")

    }
 })
 
 $(document).on('click','.bn_open_answer',function(){
   $(".bn_open_answer").empty()   
   $(".bn_open_answer").text("+")
   $(this).empty()   
   $(this).text("-")

   
   $('.rte').find($("p")).each(function(index1,item1){
        	if(index1 % 2 != 0){
      			$(this).css({"display":"none"})
    		}
        })
   if($(this).attr('data-click')){
      bn_boll = false
      $(this).removeAttr('data-click')
      	$(this).empty()   
   	  	$(this).text("+")

     }else{
     	 $(this).attr('data-click','true')
         bn_boll = true
     }
   if(bn_boll){
   	   $(this).parent().next().css({"display":"block"})
       

   }
   

 
 })
 
 var bn_features = false
 
 $(".bn_features_paragraph").click(function(){  
 
   if(!bn_features){
   		
     $(".bn_features").css({"display":"block"})
     $(".bn_features_open").empty()
     $(".bn_features_open").text("-")
     bn_features = !bn_features
     
   }else{
   	 $(".bn_features_open").empty()
     $(".bn_features_open").text("+")
     $(".bn_features").css({"display":"none"})
     bn_features = !bn_features


   }
 
 })
$( document ).ready(function() {

   var bn_winow_width =$(document).width()

if(bn_winow_width < 750){
  for( i=0; i<2; i++){
    $(".bn_feature_image_parent").css({"height":$(".bn_text_cover").height()+"px","width":$(document).width()})
    $(".bn_feature_image_parent").parent().css({"padding-top":"0"})
    console.log($(".bn_text_cover").height())    
  }
    
}
$(".bn_gallery").each(function(){
  for(i=0;i<2;i++){
    $(this).css({"height":$(this).width()+"px"})

  }


})
  
 })




// $(".cart-drawer__item-quantity").click(function(){
//   fetch('/cart.js')
//      .then(response => response.json())
//      .then(data => {
//        console.log(data)
//     })
// })
// var quantity_ = 90

// $(".product__add-to-cart-button").click(()=>{
// alert("changing");

//     let addData = {
//       "line":1,
//       'quantity':10
//     };

//   // fetch('/cart/add.js', {
//   //     method: 'POST',
//   //     credentials: 'same-origin',
//   //     headers: {
//   //       'Content-Type': 'application/json',
//   //     },
//   //     body: JSON.stringify(addData)
//   //   })
//   quantity_ *= 2

//   // fetch("cart/change.js",{
//   //   method:"POST",
//   //   credentials: "same-origin",
//   //   headers: {
//   //     "Content-Type": "aplication/json",
//   //   },
//   //   body:JSON.stringify(addData)
//   // })
//   fetch('/cart.js')
//      .then(response => response.json())
//      .then(data => {
//        console.log(data)
//     })
//   quantity_++
// })





 
